import { render, staticRenderFns } from "./HeartIconNew.vue?vue&type=template&id=2bff8974"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bff8974')) {
      api.createRecord('2bff8974', component.options)
    } else {
      api.reload('2bff8974', component.options)
    }
    module.hot.accept("./HeartIconNew.vue?vue&type=template&id=2bff8974", function () {
      api.rerender('2bff8974', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/HeartIconNew.vue"
export default component.exports